(function () {
  var CFG = window.PONTE_CONFIG;
  // Token fixo como fallback — disponível em qualquer página, mesmo sem PONTE_CONFIG
  var STOREFRONT_TOKEN = (CFG && CFG.storefrontToken) || '04ce6bfb8d6bee21350f021f2e26e070';

  var STOREFRONT_URL = 'https://usecavendishattire.shop/api/2024-10/graphql.json';
  var redirecting = false;
  var variantMapCache = {};  // cache por loja_b_product_id

  // ── Busca mapa de variantes na Storefront API da Loja B ──────────────────
  function buildVariantMap(lojaBId) {
    if (variantMapCache[lojaBId]) return variantMapCache[lojaBId];

    variantMapCache[lojaBId] = fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: '{ product(id: "gid://shopify/Product/' + lojaBId + '") {' +
               '  variants(first: 100) { edges { node {' +
               '    id selectedOptions { name value }' +
               '  } } }' +
               '} }'
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var map = {};
      var prod = data.data && data.data.product;
      if (!prod) {
        console.warn('[Ponte] Produto não encontrado na Loja B. lojaBId:', lojaBId);
        return map;
      }
      prod.variants.edges.forEach(function (edge) {
        var node = edge.node;
        // Casamento por posição — agnóstico ao idioma (Cor/Tamanho, Couleur/Taille, etc.)
        var opts = node.selectedOptions;
        if (opts.length !== 2) {
          console.warn('[Ponte] Produto com', opts.length,
                       'opções — esperado 2. Usando as 2 primeiras posições.');
        }
        var val1 = opts[0] ? opts[0].value : '';
        var val2 = opts[1] ? opts[1].value : '';
        if (!val1 || !val2) return;
        var numId = node.id.split('/').pop();
        map[val1 + '|' + val2] = numId;
      });
      var mapKeys = Object.keys(map);
      if (mapKeys.length > 0) {
        console.log('[Ponte] Exemplo de chave:', mapKeys[0]);
      }
      console.log('[Ponte] Mapa carregado:', mapKeys.length,
                  'variantes — produto', lojaBId);
      return map;
    });

    return variantMapCache[lojaBId];
  }

  // Pré-aquecimento: só na página de produto com metafield preenchido
  if (CFG && CFG.productId) {
    buildVariantMap(CFG.productId).catch(function (err) {
      console.warn('[Ponte] Falha ao pré-carregar mapa — retry no checkout:', err);
      delete variantMapCache[CFG.productId];
    });
  }

  // ── Lógica de checkout ────────────────────────────────────────────────────
  function doCheckoutRedirect(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (redirecting) return;
    redirecting = true;

    var safetyTimer = setTimeout(function () { redirecting = false; }, 12000);

    var PRODUCT_MAP = window.PONTE_PRODUCT_MAP || {};

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemContexts = cart.items.map(function (item) {
          var lojaBId = PRODUCT_MAP[String(item.product_id)] || null;
          if (!lojaBId) {
            console.warn('[Ponte] Produto sem mapeamento (ignorado):',
                         item.title, '— product_id Loja A:', item.product_id);
          }
          return { item: item, lojaBId: lojaBId };
        });

        var uniqueLojaBIds = [];
        itemContexts.forEach(function (ctx) {
          if (ctx.lojaBId && uniqueLojaBIds.indexOf(ctx.lojaBId) === -1) {
            uniqueLojaBIds.push(ctx.lojaBId);
          }
        });

        if (uniqueLojaBIds.length === 0) {
          console.warn('[Ponte] Nenhum produto mapeável no carrinho — checkout bloqueado.');
          clearTimeout(safetyTimer);
          redirecting = false;
          return;
        }

        return Promise.all(
          uniqueLojaBIds.map(function (lojaBId) {
            return buildVariantMap(lojaBId)
              .then(function (map) { return { lojaBId: lojaBId, map: map }; });
          })
        ).then(function (results) {
          var mapByProduct = {};
          results.forEach(function (r) { mapByProduct[r.lojaBId] = r.map; });

          var parts = [];
          var mappedCount = 0;
          itemContexts.forEach(function (ctx) {
            if (!ctx.lojaBId) return;
            var varMap = mapByProduct[ctx.lojaBId] || {};
            var ovv  = ctx.item.options_with_values || [];
            var val1 = ovv[0] ? ovv[0].value : null;
            var val2 = ovv[1] ? ovv[1].value : null;
            var key  = (val1 && val2) ? (val1 + '|' + val2) : null;
            var dest = key ? varMap[key] : null;
            if (!dest) {
              console.warn('[Ponte] Variante não mapeável (ignorada):',
                           ctx.item.title, '— key:', key);
            } else {
              parts.push(dest + ':' + ctx.item.quantity);
              mappedCount++;
            }
          });

          console.log('[Ponte] Carrinho:', uniqueLojaBIds.length, 'produto(s),',
                      mappedCount, 'item(ns) mapeado(s).');

          if (parts.length === 0) {
            console.warn('[Ponte] Nenhum item mapeável — checkout bloqueado' +
                         ' (Loja A sem gateway).');
            clearTimeout(safetyTimer);
            redirecting = false;
            return;
          }
          clearTimeout(safetyTimer);
          window.location.href = 'https://usecavendishattire.shop/cart/' + parts.join(',');
        });
      })
      .catch(function (err) {
        console.warn('[Ponte] Erro no redirect — checkout bloqueado:', err);
        clearTimeout(safetyTimer);
        redirecting = false;
      });
  }

  // Fix bfcache: reseta flag ao voltar pela seta do browser
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) redirecting = false;
  });

  // Click capture — gaveta (#CartDrawer-Checkout) e página /cart (#checkout)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (!btn || btn.disabled) return;
    doCheckoutRedirect(e);
  }, true);

  // Submit capture — fallback se o form for submetido programaticamente
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.id !== 'CartDrawer-Form' && f.id !== 'cart')) return;
    doCheckoutRedirect(e);
  }, true);

})();
